import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconHeadsetMic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M10 .833c-4.142 0-7.5 3.359-7.5 7.5v5.834c0 1.383 1.117 2.5 2.5 2.5h2.5V10H4.167V8.333C4.167 5.108 6.775 2.5 10 2.5s5.833 2.608 5.833 5.833V10H12.5v6.667h3.333v.833H10v1.667h5c1.383 0 2.5-1.117 2.5-2.5V8.333c0-4.141-3.358-7.5-7.5-7.5z"
	})
});
export default SvgIconHeadsetMic;
